import useCurrency from "@/hook/useCurrency";

const CurrencyExchange = ({ propertyPrice, className }) => {
  const { symbol, currency, code } = useCurrency(propertyPrice);

  return (
    <p className={`font-manropeMedium text-xl text-[#010F0A] ${className}`}>
      <span className="[direction:ltr] [unicode-bidi:embed]">
        {symbol} {currency}
      </span>
      <span className="font-normal text-[14px] text-[#596460] ml-1 [direction:ltr] [unicode-bidi:embed]">
        {code}
      </span>
    </p>
  );
};

export default CurrencyExchange;
